export default __webpack_public_path__ + "static/media/Black.360d5eb7.svg";